module.exports = __webpack_public_path__ + "static/img/emptyindex.44ecc4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/emptyindex.png
// module id = SObH
// module chunks = 1